import { render, staticRenderFns } from "./multiselect-dropdown-filter.vue?vue&type=template&id=67f1b4d8"
import script from "./multiselect-dropdown-filter.vue?vue&type=script&lang=ts"
export * from "./multiselect-dropdown-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports